import { AxiosRestApplicationClient as OnboardingRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import { onboardingAxiosClient } from '../config';

interface DIContextInterface {
  OnboardingApiClient: OnboardingRestApplicationClient;
}

export const DIContext: DIContextInterface = {
  OnboardingApiClient: onboardingAxiosClient,
};
